import React from 'react';
import { Helmet } from "react-helmet-async";
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

const Showroom = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Showroom Virtual | Save Energy</title>
      </Helmet>
      
      <NavBar />

      <main className="flex-1 w-full pb-16 flex flex-col items-center">
        {/* Banner Roxo do Cabeçalho */}
        <div className="w-full bg-[#3c1053] py-16 px-4 flex justify-center mb-12">
          <div className="max-w-4xl text-center flex flex-col items-center">
            <h1 className="text-white text-3xl md:text-5xl font-bold tracking-widest mb-4 uppercase">
              Showroom Saveenergy
            </h1>
            <p className="text-gray-200 text-base md:text-lg font-light leading-relaxed">
              Descubra nossas soluções de iluminação em uma <span className="font-bold text-white">experiência virtual imersiva</span>, <br className="hidden md:block" />com ambientes inspiradores e aplicações reais.
            </p>
          </div>
        </div>
        
        {/* Container do Tour 360 */}
        <div className="max-w-7xl w-full px-4 md:px-8">
          <div className="w-full shadow-2xl bg-white" style={{ height: '75vh' }}>
            <iframe 
              src="https://tour.meupasseiovirtual.com/view/lMpLmg9AaA9" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              allowFullScreen 
              allow="vr" 
              title="Showroom Virtual Save Energy"
              className="w-full h-full block"
            ></iframe>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Showroom;